/*eslint eqeqeq: "off"*/
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import * as React from 'react';
import * as hmiclientsdata from '../../hmilib/hmiclientsdata';
import DialogParams from './DialogParams';
import TrendsGraphs, { TrendHandle } from './TrendGraph';
import TrendsTable from './TrendsTable';
import './trendsdindex.css';

//import Popover from '@mui/material/Popover';
import { Button, TextField } from '@mui/material';
import { ReadProcessed } from 'components/hmilib/api';
import LoadPage from '../../MainPage/LoadPage';
import { ButtonIcon } from '../../button';
import { IDataHistory } from '../../hmilib/hmiclientsdata';

export interface ITrendAreas {
    coordRange: any[][];
}

export interface ITrendBrush {
    areas: ITrendAreas[];
}

export interface ITrendData {
    id: string;
    brush: ITrendBrush;
    showLoading?: any;
    hideLoading?: any;
    dispatchAction(payload: any): void;
    on(eventName: string, handler: Function): void;
    off(eventName: string, handler: Function): void;
    setParam(param: ITrendParam): void;

    addPen(pen: IPens, data: any[]): number;
    delPen(idPen: number): number;
    clearTrend(): void;
}

export interface IConfig {
    theme: string;
    tagConfig?: IPens[];
    idTrend: string;
    settings: ISettingsGraph;
}

interface ISettingsGraph {
    chart: IChart;
}

interface IChart {
    topmenu: boolean;
    bottommenu: boolean;
    tagonly: boolean;
    hasHistory: boolean;
    TypeTrend: number;
    hasLegend?: boolean;
    xAxis?: IAxisSetting | IAxisSetting[] | undefined;
    yAxis?: IAxisSetting | IAxisSetting[] | undefined;
    Title: string;
    radar?: any;
}

export interface IAxisSetting {
    type: string;
    min?: string;
    max?: string;
    delta?: string;
    name?: string;
}

export interface IPens {
    id: number;
    selected?: boolean;
    enable: boolean;
    name: string;
    curvalue?: string;
    desc?: string;
    eudesc?: string;
    min?: any;
    max?: any;
    color: string;
    typeLine: string | 'line' | 'linePoint' | 'point' | 'step' | 'areadiscrete' | 'radar';
    typeScale: string | 'auto' | 'system' | 'custom';
    yAxisIndex: number | undefined;
    markArea?: any[];
}

interface Iconfigplugin {
    config?: string;
    id: string | undefined;
}

interface ITrendParamDetail {
    config?: IConfig;
}

interface ITrendParamOptions {
    series?: { [id: string]: any[] };
    settings?: ISettingsGraph;
}

interface ITrendParam {
    detail?: ITrendParamDetail;
    options?: ITrendParamOptions;
}

const TrendsIndex = (prop: Iconfigplugin) => {
    let coloritem = [
        '#00ccff',
        '#967474',
        '#00cc00',
        '#ffcc00',
        '#ff00ff',
        '#ff0000',
        '#0000ff',
        '#8400ff',
        '#00ff84',
        '#ff8200',
        '#ff0084',
        '#84ffff',
        '#c6c3c6',
        '#84ff00',
        '#ffff84',
        '#ff82ff',
        '#ff8284',
        '#0082ff',
        '#8482ff',
        '#84ff84',
        '#ff8242',
        '#ff82c6',
        '#008284',
        '#848284',
        '#008200',
        '#848200',
        '#840084',
        '#840000',
        '#000084',
        '#420084',
        '#008242',
        '#844100'
    ];

    const listAction = ['onbrushselected'];

    const [dialogisopen, setDiaalog] = React.useState(false);

    const [dialogisopenEdit, setDiaalogEdit] = React.useState(-1);

    const defaultDelta = -2 * 3600 * 1000;
    const toDateTimeString = function (date: Date): string {
        let str = '';
        let year, month, day, hour, min, sec;
        year = date.getFullYear();
        month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        day = date.getDate();
        day = day < 10 ? '0' + day : day;
        hour = date.getHours();
        hour = hour < 10 ? '0' + hour : hour;
        min = date.getMinutes();
        min = min < 10 ? '0' + min : min;

        sec = date.getSeconds();
        sec = sec < 10 ? '0' + sec : sec;

        str += year + '-' + month + '-' + day;
        str += 'T' + hour + ':' + min + ':' + sec;

        return str;
    };

    const [config, setConfig] = React.useState<IConfig>({
        idTrend: '',
        theme: '',
        settings: {
            chart: {
                bottommenu: true,
                hasHistory: true,
                tagonly: true,
                Title: 'demo',
                topmenu: true,
                TypeTrend: 1,
                hasLegend: true,
                xAxis: {
                    type: 'time',
                    delta: 'MAN'
                }
            }
        }
    });
    //Обновление точек на графике
    const [newSeriesPoints, setNewSeriesPoints] = React.useState<any[]>([]);

    const [group, setGroup] = React.useState(0);

    const [load, setLoad] = React.useState(false);

    ///обновление графика
    const [notMerge, setnotMerge] = React.useState(false);

    const [idTrend, setidTrend] = React.useState<string | undefined>(undefined);

    const [xStart, setXStart] = React.useState<string | undefined>(undefined);
    const [xEnd, setXEnd] = React.useState<string | undefined>(undefined);

    const [archiveTrend, setArchiveTrend] = React.useState(false);

    const [archive, setArchive] = React.useState<{ [id: string]: [] }>({});

    const [HmiHistorySettings, setHmiHistorySettings] = React.useState<IPens[] | undefined>(undefined);

    const [paramupdateArchiveItems, setparamupdateArchiveItems] = React.useState<string[]>([]);

    const [visibleBottomMenu, setvisibleBottomMenu] = React.useState(true);

    const [visibleTopMenu, setvisibleTopMenu] = React.useState(true);

    const [HeightGraph, setHeightGraph] = React.useState('100%');
    const [HeightTopMenu, setHeightTopMenu] = React.useState('');
    const [HeightTitle, setHeightTitle] = React.useState('23px');

    const [HeightBootomMenu, setHeightBootomMenu] = React.useState('100%');

    //Для обновления таблицы, без данного обновления пи смене группы не происходит обновление шкал
    const [keyTable, setkeyTable] = React.useState(0);

    React.useEffect(() => {
        //HeightBootomMenu
        let Titleh: string = '0%';
        let topmenuhe: string = '0%';
        let graphh: string = '0%';
        let bootomh: string = '0%';
        let ContainerHeigh = myRef.current?.clientHeight;

        if (config.settings.chart.Title != null && config.settings.chart.Title != '' && ContainerHeigh) {
            Titleh = (24 / ContainerHeigh) * 100 + '%';
        }

        if (visibleTopMenu && ContainerHeigh) {
            topmenuhe = (24 / ContainerHeigh) * 100 + '%';
        }

        if (visibleBottomMenu && ContainerHeigh) {
            bootomh = ((32 * 4) / ContainerHeigh) * 100 + '%';
        }

        setHeightTopMenu(topmenuhe);

        setHeightBootomMenu(bootomh);

        setHeightTitle(Titleh);

        setHeightGraph('calc(100% - ' + topmenuhe + ' - ' + bootomh + ' - ' + Titleh + ')');
    }, [visibleBottomMenu, visibleTopMenu, config.settings.chart.Title]);

    React.useEffect(() => {
        if (paramupdateArchiveItems.length != 0) {
            UpdateArchiveItems(paramupdateArchiveItems);
        }
    }, [paramupdateArchiveItems]);

    const myRef = React.createRef<HTMLDivElement>();

    React.useEffect(() => {
        let newid: string = prop.id ? prop.id : self.crypto.randomUUID();

        setidTrend(newid);

        return () => {
            window.Trends.RemoveTrend(newid);
        };
    }, [prop.id]);

    React.useEffect(() => {}, [idTrend]);

    const [actionOn, setActionOn] = React.useState<Record<string, Function[]>>({});

    React.useEffect(() => {
        if (idTrend) {
            let id = idTrend;

            let trend = window.Trends.IntTrend(id);

            let containerId: any = myRef?.current?.parentNode;
            if (containerId) {
                containerId.getTrendInit = () => {
                    return trend;
                };
            }

            if (trend) {
                trend.setParam = function (data: any) {
                    updateParam(data);
                };

                trend.addPen = function (pen: IPens, data: any[]) {
                    let newconfig: IConfig = JSON.parse(JSON.stringify(config));
                    if (newconfig.tagConfig == null) {
                        newconfig.tagConfig = [];
                    }
                    newconfig.tagConfig?.push(pen);

                    let param: ITrendParam = {
                        detail: { config: newconfig },
                        options: {
                            series: {}
                        }
                    };

                    if (param.options?.series) {
                        for (const [key, value] of Object.entries(archive)) {
                            let tempvaluex: any[] = [];
                            let tempvaluey: any[] = [];
                            value.map(function (item) {
                                tempvaluex.push(item[0]);
                                tempvaluey.push(item[1]);
                            });

                            param.options.series[key] = [tempvaluex, tempvaluey];
                        }

                        param.options.series[pen.name] = data;
                    }
                    updateParam(param);
                    return newconfig.tagConfig.length - 1;
                };

                trend.clearTrend = function () {
                    let newconfig: IConfig = JSON.parse(JSON.stringify(config));

                    newconfig.tagConfig = [];

                    let param: ITrendParam = {
                        detail: {
                            config: newconfig
                        },
                        options: {
                            series: {}
                        }
                    };
                    updateParam(param);
                };

                trend.delPen = function (idPen: number) {
                    let res = -1;
                    let newconfig: IConfig = JSON.parse(JSON.stringify(config));
                    let newarchive = archive;

                    if (newconfig.tagConfig) {
                        if (newconfig.tagConfig?.length > idPen) {
                            let nameDel = newconfig.tagConfig[idPen].name;
                            delete newarchive[nameDel];

                            newconfig.tagConfig?.splice(idPen, 1);

                            let param: ITrendParam = {
                                detail: { config: newconfig },
                                options: {
                                    series: {}
                                }
                            };

                            if (param.options?.series) {
                                for (const [key, value] of Object.entries(archive)) {
                                    if (key != nameDel) {
                                        let tempvaluex: any[] = [];
                                        let tempvaluey: any[] = [];
                                        value.map(function (item) {
                                            tempvaluex.push(item[0]);
                                            tempvaluey.push(item[1]);
                                        });

                                        param.options.series[key] = [tempvaluex, tempvaluey];
                                    }
                                }
                            }

                            updateParam(param);
                            res = 1;
                        }
                    }

                    return res;
                };

                trend.showLoading = function () {
                    setLoad(true);
                };

                trend.hideLoading = function () {
                    setLoad(false);
                };

                trend.dispatchAction = function (payload: any) {
                    if (payload) {
                        payload.type = payload.type?.toLowerCase();
                        if (actionOn[payload.type]) {
                            for (let paramind = actionOn[payload.type].length; paramind--; ) {
                                actionOn[payload.type][paramind].call(trend, payload.data);
                            }
                        }

                        let handletxt = containerId.getAttribute('on' + payload.type);
                        if (handletxt) {
                            ((data: any) => {
                                eval(handletxt);
                            }).call(trend, payload.data);
                        }
                    }
                };

                trend.on = function (eventName: string, handler: Function) {
                    let actionOnTemp = { ...actionOn };
                    eventName = eventName.toLowerCase();

                    if (actionOnTemp[eventName] == null) {
                        actionOnTemp[eventName] = [];
                    }

                    actionOnTemp[eventName].push(handler);
                    setActionOn(actionOnTemp);
                };

                trend.off = function (eventName: string, handler: Function) {
                    let actionOnTemp = { ...actionOn };
                    eventName = eventName.toLowerCase();
                    if (actionOnTemp[eventName]) {
                        for (let paramind = actionOn[eventName].length; paramind--; ) {
                            if (actionOn[eventName][paramind] == handler) {
                                actionOnTemp[eventName].splice(paramind, 1);
                                paramind++;
                            }
                        }

                        setActionOn(actionOnTemp);
                    }
                };
            }
        }
    });

    const isObject = function (item: any) {
        return item && typeof item === 'object' && !Array.isArray(item);
    };

    const Object_assign = function (target: any, ...sources: any): any {
        if (!sources.length) return target;
        const source = sources.shift();

        if ((isObject(target) || null) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    if (!isObject(target[key])) {
                        target[key] = {};
                    }
                    Object_assign(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return Object_assign(target, ...sources);
    };

    const updateParam = (data: ITrendParam) => {
        if (data) {
            let configloc = data?.detail?.config;

            if (configloc) {
                let newconfig: IConfig = Object_assign(config, configloc);

                SetConfigNew(newconfig);

                setArchiveTrend(true);

                let s: string[] = [];

                if (newconfig.tagConfig != undefined) {
                    for (let i = 0; i < newconfig.tagConfig.length; i++) {
                        if (newconfig.tagConfig[i].name != '') s.push(newconfig.tagConfig[i].name);
                    }

                    setparamupdateArchiveItems(s);
                }
            }

            if (data.options) {
                if (data.options.settings?.chart) {
                    if (data.options.settings.chart.hasHistory != undefined) {
                        sethasHistory(data.options.settings.chart.hasHistory);
                    }

                    if (data.options.settings?.chart?.bottommenu != undefined)
                        setvisibleBottomMenu(data.options.settings.chart.bottommenu);
                    if (data.options.settings?.chart?.topmenu != undefined)
                        setvisibleTopMenu(data.options.settings.chart.topmenu);
                }

                if (data.options.series) {
                    if (HmiHistorySettings) {
                        let datas: any[] = [];

                        for (let item of Object.keys(data.options.series)) {
                            if (data.options.series[item]) {
                                let newdata: IDataHistory = {
                                    ID: item,
                                    Q: data.options.series[item][2],
                                    T: data.options.series[item][0],
                                    V: data.options.series[item][1]
                                };
                                datas.push(newdata);
                            }
                        }

                        setArchiveTrend(true);

                        updateDataParam(datas);
                    }
                }
            }
        }
    };

    const [hasHistory, sethasHistory] = React.useState<boolean>(false);

    const [newListItems, setnewListItems] = React.useState<string[]>([]);

    React.useEffect(() => {
        updateTag(newListItems, '', -1, hasHistory);
    }, [newListItems, hasHistory]);

    const SetConfigNew = function (confignew: IConfig) {
        if (confignew.settings.chart.xAxis) {
            if (
                (confignew.settings.chart.xAxis as IAxisSetting)?.delta?.includes('h') &&
                (confignew.settings.chart.xAxis as IAxisSetting)?.type == 'time'
            ) {
                if ((confignew.settings.chart.xAxis as IAxisSetting)?.max == null) {
                    let xDelta =
                        Number((confignew.settings.chart.xAxis as IAxisSetting)?.delta?.replaceAll('h', '')) * 3600000;
                    let min = window.ConvertDateISOtoNs(new Date(window.SystemDate().setMilliseconds(xDelta)));
                    let max = window.ConvertDateISOtoNs(new Date(window.SystemDate().setMilliseconds(5000)));

                    (confignew.settings.chart.xAxis as IAxisSetting).min = min;
                    (confignew.settings.chart.xAxis as IAxisSetting).max = max;
                }
            }
        }

        if (confignew.tagConfig) {
            for (let i = 0; i < confignew.tagConfig?.length; i++) {
                confignew.tagConfig[i].enable =
                    confignew.tagConfig[i].enable == null || confignew.tagConfig[i].enable == true ? true : false;
            }
        }

        let max = null;
        let min = null;
        if (
            (confignew.settings.chart.xAxis as IAxisSetting)?.min != '' &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.min != null
        ) {
            min = (confignew.settings.chart.xAxis as IAxisSetting).min;
            if ((confignew.settings.chart.xAxis as IAxisSetting).type == 'time') {
                min = GetDate(min);
                (confignew.settings.chart.xAxis as IAxisSetting).min = min;
            }

            setXStart(min);
        }

        if (
            confignew.settings.chart.xAxis &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.max != '' &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.max != null
        ) {
            max = (confignew.settings.chart.xAxis as IAxisSetting).max;
            if ((confignew.settings.chart.xAxis as IAxisSetting).type == 'time') {
                max = GetDate(max);
                (confignew.settings.chart.xAxis as IAxisSetting).max = max;
            }

            setXEnd(max);
        } else if (min == null && max == null) {
            console.log('not set xAxis');
        }

        setConfig(confignew);
    };

    React.useEffect(() => {
        let configloc = config;

        if (prop.config) {
            configloc = JSON.parse(prop.config);

            let newconfig = Object_assign(config, configloc);

            SetConfigNew(newconfig);
        }

        setvisibleBottomMenu(configloc.settings.chart.bottommenu);
        setvisibleTopMenu(configloc.settings.chart.topmenu);

        let hasHistorytemp = configloc.settings.chart.hasHistory;

        sethasHistory(hasHistorytemp);
        if (configloc.tagConfig && configloc.tagConfig?.length != 0) {
            let items = [];
            for (let pen = 0; pen < configloc.tagConfig.length; pen++) {
                coloritem[pen] = configloc.tagConfig[pen].color;
                items.push(configloc.tagConfig[pen].name);
            }

            setnewListItems(items);
        } else if (configloc.idTrend != '$ID' && configloc.idTrend != '') {
            if (!archiveTrend) updateGroup(Number(configloc.idTrend), '', hasHistorytemp);
        } else {
            setDiaalog(true);
        }

        return () => {
            window.parent.UnSubItems(Object.keys(archive));
        };
    }, []);

    /*
    React.useEffect(() => {

        const timer = setInterval(() => {  

            Update();
        }, UpdateGraphInterval);

        return () => clearInterval(timer);
    });*/

    const UpdateGraphInterval = 1000;

    const [iUpdateX, setiUpdateX] = React.useState<number>(0);
    const MaxUpdateX = 5;

    async function Update() {
        try {
            if (HmiHistorySettings && !archiveTrend) {
                let newseries: any = {};
                for (let paramind = HmiHistorySettings.length; paramind--; ) {
                    if (HmiHistorySettings[paramind].name != '') {
                        let parnew = window.parent.GetParam(HmiHistorySettings[paramind].name);
                        let val = parnew.V;
                        let t = window.SystemDate();

                        newseries[paramind] = [[t, val]];
                    }
                }

                // await UpdateArchive(newseries);

                setNewSeriesPoints(newseries);

                if (iUpdateX == 0) {
                    let newconfig = { ...config };

                    if (newconfig.settings?.chart?.xAxis as IAxisSetting) {
                        (newconfig.settings.chart.xAxis as IAxisSetting).max = window.ConvertDateISOtoNs(
                            new Date(window.SystemDate().setMilliseconds(MaxUpdateX * UpdateGraphInterval))
                        );
                    }
                    SetConfigNew(newconfig);
                }

                if (iUpdateX >= MaxUpdateX) {
                    setiUpdateX(0);
                } else {
                    setiUpdateX(iUpdateX + 1);
                }
            }
        } catch (ex) {
            console.dir(ex);
        }
    }

    const UpdateArchive = (newseries: any[]) => {
        if (HmiHistorySettings) {
            let cloneHmiHistory = HmiHistorySettings.slice();

            let temparchive: any = {};

            temparchive = JSON.parse(JSON.stringify(archive));

            for (let paramind = HmiHistorySettings.length; paramind--; ) {
                if (newseries[paramind]) {
                    for (let i in newseries[paramind]) {
                        let val = Number(newseries[paramind][i][1]);
                        let t = newseries[paramind][i][0];

                        let len = temparchive[cloneHmiHistory[paramind].name].length;
                        if (len > 2) {
                            if (xStart) {
                                if (temparchive[cloneHmiHistory[paramind].name][1][0] < xStart) {
                                    temparchive[cloneHmiHistory[paramind].name].shift();
                                    len--;
                                }
                            }

                            let lastval = temparchive[cloneHmiHistory[paramind].name][len - 1];

                            if (temparchive[cloneHmiHistory[paramind].name][len - 2][1] == lastval[1]) {
                                temparchive[cloneHmiHistory[paramind].name][len - 2][0] = lastval[0];
                                temparchive[cloneHmiHistory[paramind].name].pop();
                                len--;
                            }
                        }

                        if (len > 0) {
                            if (t > temparchive[cloneHmiHistory[paramind].name][len - 1][0]) {
                                temparchive[cloneHmiHistory[paramind].name].push([t.toISOString(), val]);
                                if (cloneHmiHistory[paramind].typeScale === 'auto') {
                                    if (cloneHmiHistory[paramind].max < val) {
                                        let scaleminmax = Math.abs(Number(val) - Number(cloneHmiHistory[paramind].min));
                                        cloneHmiHistory[paramind].max = Number(Number(val) + scaleminmax * 0.1).toFixed(
                                            3
                                        );
                                    } else if (cloneHmiHistory[paramind].min > val) {
                                        let scaleminmax = Math.abs(Number(cloneHmiHistory[paramind].max) - Number(val));
                                        cloneHmiHistory[paramind].min = Number(Number(val) - scaleminmax * 0.1).toFixed(
                                            3
                                        );
                                    }
                                }
                            } else {
                                temparchive[cloneHmiHistory[paramind].name].push([
                                    window.SystemDate().toISOString(),
                                    val
                                ]);
                            }
                        } else {
                            temparchive[cloneHmiHistory[paramind].name].push([t.toISOString(), val]);
                            let scaleminmax = Math.abs(Number(val));
                            cloneHmiHistory[paramind].max = Number(Number(val) + scaleminmax * 0.1).toFixed(3);
                            cloneHmiHistory[paramind].min = Number(Number(val) - scaleminmax * 0.1).toFixed(3);
                        }

                        cloneHmiHistory[paramind].curvalue = val.toString();
                    }
                }
            }

            setArchive(temparchive);
            setHmiHistorySettings(cloneHmiHistory);
        }
    };

    useInterval(Update, UpdateGraphInterval);

    const updateGroup = (newgroup: number, Select: string, hasHistory = true) => {
        setDiaalog(false);

        let groupnum = Number(newgroup);
        setGroup(groupnum);

        let hist = hmiclientsdata.GetHistorySettings()[newgroup];
        if (hist != null) {
            let Items = [];
            for (let key in hist) {
                if (hist[key].param != '') {
                    Items.push(hist[key].param);
                }
            }

            updateTag(Items, Select, newgroup);
        } else {
            updateDataParam([], newgroup, Select);
        }
    };

    const getMinMax_markArea = (data: IDataHistory) => {
        let newMin: number | null = null;
        let newMax: number | null = null;

        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };
        let startMarkArea: boolean = false;

        for (let i = data.V.length; i--; ) {
            let val = data.V[i];

            if (data.Q) {
                if (data.Q[i] !== 0) {
                    if (!startMarkArea) {
                        if (data.V.length !== i) {
                            tempMarkArea.data.unshift([{}, { xAxis: GetDate(data.T[i]) }]);
                            startMarkArea = true;
                        }
                    }
                } else {
                    if (startMarkArea) {
                        tempMarkArea.data[0][0].xAxis = GetDate(data.T[i + 1]);
                        startMarkArea = false;
                    }
                }
            }

            if (!Number.isNaN(Number(val))) {
                if (newMin === null || Number.isNaN(newMin)) {
                    newMin = val;
                }
                if (newMax === null || Number.isNaN(newMax)) {
                    newMax = val;
                }
            }
            if (newMin != null && newMax != null) {
                if (val > newMax) {
                    newMax = val;
                } else if (val < newMin) {
                    newMin = val;
                }
            }
        }

        let scaleminmax = Math.abs(Number(newMax?.toFixed(3)) - Number(newMin?.toFixed(3)));
        scaleminmax = Number(scaleminmax.toFixed(3));
        if (scaleminmax === 0) {
            scaleminmax = 1;
        } else if (scaleminmax < 0.2) {
            scaleminmax = 0.2;
        }

        let max = '0';
        if (newMax != null) {
            max = Number(newMax + scaleminmax * 0.05).toFixed(3);
        }
        let min = '0';
        if (newMin != null) {
            min = Number(newMin - scaleminmax * 0.05).toFixed(3);
        }

        return { max: max, min: min, markArea: tempMarkArea };
    };

    let echarts_react: any = undefined;

    const UpdateEnableState = (id: number, state: boolean) => {
        if (HmiHistorySettings) {
            let itemsAlarm = HmiHistorySettings.slice();
            itemsAlarm[id - 1].enable = state;
            setHmiHistorySettings(itemsAlarm);

            setnotMerge(true);
            setTimeout(() => setnotMerge(false), 2000);
        }
    };

    const UpdateMin = (id: number, val: number) => {
        if (HmiHistorySettings) {
            let itemsAlarm = HmiHistorySettings.slice();
            itemsAlarm[id - 1].min = val;
            setHmiHistorySettings(itemsAlarm);
        }
    };

    const UpdateMax = (id: number, val: number) => {
        if (HmiHistorySettings) {
            let itemsAlarm = HmiHistorySettings.slice();
            itemsAlarm[id - 1].max = val;
            setHmiHistorySettings(itemsAlarm);
        }
    };

    const updateDataParam = (
        data: IDataHistory[],
        group: number | undefined = undefined,
        Select: string | undefined = undefined
    ) => {
        if (Select == '' || Select == null || '$SELECT' == Select) {
            Select = '';
        }
        Select = Select.toUpperCase();

        window.parent.SubItems(data.map((ele) => ele.ID));

        let newdataobj: any = {};

        if (data) {
            // let temparchive = { ...archive };
            let temparchive = {};
            let tempHmiHistorySettings: IPens[] = new Array(coloritem.length);
            let tempColor: any[] = [];
            if (HmiHistorySettings !== undefined) {
                // tempHmiHistorySettings = HmiHistorySettings.slice();
                HmiHistorySettings.forEach((item) => {
                    tempColor.push(item.color);
                });
            }

            let HistorySettings: any = undefined;
            if (group != undefined && group != 0) {
                HistorySettings = hmiclientsdata.GetHistorySettings()[group];
            }

            let activeitem = false;

            let endtimeiso = xEnd;

            let idlist = 0;

            for (let id2 in data) {
                idlist++;
                let name = data[id2].ID;
                let lastTime = data[id2].T[data[id2].T.length - 1];

                if (!archiveTrend) {
                    if (lastTime < Number(endtimeiso)) {
                        let parnew = window.parent.GetParam(name);
                        if (parnew.V != name) {
                            let val = Number(Number(parnew.V).toFixed(3));
                            data[id2].T.push(window.ConvertDateISOtoNs(window.SystemDate()));
                            data[id2].Q?.push(Number(parnew.Q));
                            data[id2].V.push(val);
                        }
                    }
                }

                let minMax_markArea = getMinMax_markArea(data[id2]);

                let newdata = [];

                //newdata = data[id2];

                for (let ida = data[id2].V.length; ida--; ) {
                    let val = data[id2].V[ida];
                    if ((config.settings.chart?.xAxis as IAxisSetting)?.type != 'time') {
                        newdata.unshift([data[id2].T[ida], val]);
                    } else {
                        newdata.unshift([GetDate(data[id2].T[ida]), val]);
                    }
                }

                let HistSettings = tempHmiHistorySettings.filter((f) => f.name == name)[0];

                if (HistSettings?.selected) {
                    activeitem = true;
                }

                let desc = '';
                // let TempColor = config.tagConfig[id2].color;
                let eudesc = '';
                HistSettings = CreateItem(idlist, name, desc, eudesc, undefined, 'auto');

                tempHmiHistorySettings[idlist - 1] = HistSettings;
                // tempHmiHistorySettings[idlist - 1].color = tempColor[idlist-1];

                HistSettings.max = minMax_markArea.max;
                HistSettings.min = minMax_markArea.min;
                HistSettings.markArea = minMax_markArea.markArea;

                if (HistorySettings != null) {
                    if (HistorySettings[idlist - 1].min != null) {
                        HistSettings.min = HistorySettings[idlist - 1].min;
                    }

                    if (HistorySettings[idlist - 1].max != null) {
                        HistSettings.max = HistorySettings[idlist - 1].max;
                    }

                    let enable = HistorySettings[idlist - 1].enable;
                    let step = HistorySettings[idlist - 1].step;
                    HistSettings.enable = enable;
                }

                newdataobj[name] = newdata;
            }

            for (let i = 0; i < tempHmiHistorySettings.length; i++) {
                if (!tempHmiHistorySettings[i]) {
                    let active = false;
                    //if (!activeitem) active = true;
                    tempHmiHistorySettings[i] = {
                        id: i + 1,
                        color: coloritem[i],
                        curvalue: '',
                        yAxisIndex: undefined,
                        desc: '',
                        eudesc: '',
                        min: 0,
                        max: 100,
                        enable: false,
                        name: '',
                        selected: active,
                        typeLine: 'line',
                        typeScale: 'auto'
                    };
                }

                if (
                    (tempHmiHistorySettings[i].name.indexOf(Select) == 0 && Select != '') ||
                    (!activeitem && Select == '') ||
                    (!activeitem && Select == undefined)
                ) {
                    tempHmiHistorySettings[i].selected = true;
                    activeitem = true;
                }
            }

            let temparchivenew = { ...temparchive, ...newdataobj };

            setArchive(temparchivenew);
            setHmiHistorySettings(tempHmiHistorySettings);

            setnotMerge(true);
            setTimeout(() => setnotMerge(false), 2000);

            setkeyTable(keyTable + 1);
        }
    };

    const GetDate = (datelong: any) => {
        if (typeof datelong == 'number') {
            return window.ConvertDateNsToISO(datelong);
        } else {
            return new Date(datelong);
        }
    };

    const calbacUpdateRow = (index: number) => {
        if (index !== -1) {
            if (HmiHistorySettings) {
                let itemsAlarm = HmiHistorySettings.slice();
                for (let j = itemsAlarm.length; j--; ) {
                    itemsAlarm[j].selected = false;
                }

                itemsAlarm[index].selected = true;
                setHmiHistorySettings(itemsAlarm);
            }
        }
    };

    const callbackSave = (id: number, param: string, typeLine: string, typeScale: string, color: string) => {
        if (id > 0 && id != null) {
            if (HmiHistorySettings) {
                let newconfig: IConfig = { ...config };
                if (newconfig.tagConfig) {
                    if (newconfig.tagConfig.length >= id - 1) {
                        let newPen: IPens = {
                            id: id,
                            selected: true,
                            enable: true,
                            typeScale: 'auto',
                            color: color,
                            name: param,
                            typeLine: typeLine,
                            yAxisIndex: newconfig?.tagConfig[id - 1]?.yAxisIndex || undefined
                        };
                        newconfig.tagConfig[id - 1] = newPen;
                    }
                }

                SetConfigNew(newconfig);

                let itemsAlarm = [...HmiHistorySettings];

                for (let j = itemsAlarm.length; j--; ) {
                    itemsAlarm[j].selected = false;
                }

                if (itemsAlarm[id - 1].name != '') window.parent.UnSubItems([itemsAlarm[id - 1].name]);

                //Для теста, потом изменить
                let desc = '';
                let eudesc = '';
                let itemalarm: IPens = CreateItem(id, param, desc, eudesc, typeLine, typeScale, color);
                itemalarm.selected = true;
                itemsAlarm[id - 1] = itemalarm;

                setHmiHistorySettings(itemsAlarm);
                // window.parent.SubItems([param]);

                // updateTag([param], config.Select);

                // setparamupdateArchiveItems([param]);
                const archiveItems = Object.keys(archive);

                for (let i = 0; i < archiveItems.length; i++) {
                    if (i === id - 1) {
                        archiveItems[i] = param;
                    }
                }

                if (!archiveItems.includes(param)) {
                    archiveItems.push(param);
                }

                const Items = archiveItems;

                setparamupdateArchiveItems(Items);
            }
        } else {
            console.log('Save trend: id null');
        }
        setDiaalogEdit(-1);
    };

    let CreateItem = function (
        id: number,
        param: string,
        desc: string,
        eudesc: string,
        typeLine: string | undefined,
        typeScale: string,
        colorItem?: string
    ): IPens {
        let item = param.toUpperCase().substr(0, param.lastIndexOf('.'));

        if (item.indexOf('.VALUE') != -1) {
            item = param.toUpperCase().substr(0, item.lastIndexOf('.'));
        }

        let curvalue = Number(window.parent.GetParam(param).V).toFixed(3);

        let tempDesc = '';
        let tempEudesc = '';

        let minmax = 1;
        if (Number(curvalue) > 1) {
            minmax = Number(curvalue) * 2;
        }

        let min = (Number(window.parent.GetParam(param).V) - minmax).toFixed(3);
        let max = (Number(window.parent.GetParam(param).V) + minmax).toFixed(3);
        let index = id;

        let color = coloritem[index - 1];
        if (colorItem !== undefined) {
            color = colorItem;
        }

        let enable = true;
        let yAxisIndex = undefined;

        if (config.tagConfig) {
            if (typeLine == null) {
                typeLine = config.tagConfig[id - 1]?.typeLine || 'line';
            }

            yAxisIndex =
                config.tagConfig[id - 1]?.yAxisIndex != null ? config.tagConfig[id - 1]?.yAxisIndex : yAxisIndex;

            enable = config.tagConfig[id - 1]?.enable;
            if (config.tagConfig[id - 1]?.color !== undefined) {
                color = config.tagConfig[id - 1]?.color;
            }
            tempDesc = config.tagConfig[id - 1]?.desc || '';
            tempEudesc = config.tagConfig[id - 1].eudesc || '';
        }

        if (tempDesc == '' || tempDesc == null) {
            desc = window.parent.GetParam(item + '.description').V;
            if (desc == '.description' || desc == null || desc == 'null') desc = '';
        } else {
            desc = window.parent.GetParam(tempDesc).V;
        }

        if (tempEudesc !== null) {
            eudesc = window.parent.GetParam(tempEudesc).V;
        }

        if (typeLine == null) {
            typeLine = 'line';
        }
        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };

        let itemalarm: IPens = {
            id: id,
            color: color,
            curvalue: curvalue,
            desc: desc,
            eudesc: eudesc,
            min: min,
            max: max,
            enable: enable,
            name: param,
            selected: false,
            typeLine: typeLine,
            typeScale: typeScale,
            yAxisIndex: yAxisIndex,
            markArea: tempMarkArea
        };
        return itemalarm;
    };

    const updateTag = (Items: string[], Select: string, newgroup = -1, hasHistory = true) => {
        if (hasHistory) {
            ReadHistoryData(Items).then((data: any) => {
                if (data) {
                    updateDataParam(data, newgroup, Select);
                }
            });

            //hmiclientbase.ReadRawAsync(Items, starttimeiso, endtimeiso, 0, 1).then((data: any) => { if (data) { ConstrData(data, newgroup, Select) } });
        } else {
            let datas: any = [];
            for (let item in Items) {
                let data: IDataHistory = { ID: item, Q: [], T: [], V: [] };
                datas.push(data);
            }

            updateDataParam(datas, newgroup, Select);
        }
        // console.log('updateTag')
    };

    const UpdateArchiveItems = function (param: string[]) {
        if (hasHistory) {
            setArchive({});

            setLoad(true);
            ReadHistoryData(param).then((data: any) => {
                setLoad(false);
                if (data) {
                    updateDataParam(data);
                }
            });
        }

        //hmiclientbase.ReadRawAsync(param, starttimeiso, endtimeiso, 0, 1).then((data: any) => { updateDataParam(data) });
    };

    const ReadHistoryData = async function (Items: string[]) {
        if (xStart && xEnd) {
            let starttimeiso = new Date(xStart).toISOString();
            let endtimeiso = new Date(xEnd).toISOString();

            let funcName: string[] = [];
            Items.forEach((element) => funcName.push('INTERPOLATIVE'));

            let maxPoint = 7200;
            let countPoint = maxPoint;

            let deltaNs = (new Date(xEnd).getTime() - new Date(xStart).getTime()) * 1000000;

            let intervalNs = Math.floor(deltaNs / countPoint);

            return ReadProcessed(Items, funcName, starttimeiso, endtimeiso, intervalNs);
        }
    };

    const ChangeItem = (e: any, id: number) => {
        setDiaalogEdit(id);

        console.log(id);

        e.preventDefault();
    };

    const calbackClickRow = (e: any) => {
        let i = e.event.currentTarget.getAttribute('aria-rowindex');
        let index = Number(i) - 1;

        calbacUpdateRow(index);
    };

    const handleChangeTrendIndex = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        //const name = event.target.name;
        let numgroup = event.target.value;
        if (numgroup != null) {
            let numgroupNumber = Number(numgroup);
            if (numgroupNumber != null) {
                setGroup(numgroupNumber);
            }
        }
    };

    const handleSetTrendIndex = (event: React.KeyboardEvent<HTMLElement>) => {
        //const name = event.target.name;
        if (event.keyCode == 13) {
            let numgroup = (event.target as HTMLInputElement).value;
            if (numgroup != null) {
                let numgroupNumber = Number(numgroup);
                if (numgroupNumber != null) {
                    setHmiHistorySettings(undefined);
                    updateGroup(numgroupNumber, '');
                }
            }
        }
    };

    const graphRef = React.useRef<TrendHandle>(null);

    const [activeTopBut, setActiveTopBut] = React.useState('');

    if (dialogisopenEdit !== -1)
        return (
            <DialogParams
                callbackSave={callbackSave}
                id={dialogisopenEdit}
                namePoint={HmiHistorySettings ? HmiHistorySettings[dialogisopenEdit - 1].name : ''}
                hexColor={HmiHistorySettings ? HmiHistorySettings[dialogisopenEdit - 1].color : '#000000'}
                typeLine={HmiHistorySettings ? HmiHistorySettings[dialogisopenEdit - 1].typeLine : 'line'}
                typeScale={HmiHistorySettings ? HmiHistorySettings[dialogisopenEdit - 1].typeScale : 'auto'}
            />
        );

    if (HmiHistorySettings && idTrend) {
        return (
            <div ref={myRef} className={'trendsplugin'}>
                <LoadPage visible={load} />

                <div
                    style={{
                        fontFamily: 'Roboto',
                        fontWeight: 400,
                        fontSize: '13px',
                        color: '#4C4B4B',
                        padding: HeightTitle == '0%' ? '' : '5px'
                    }}>
                    {config.settings.chart.Title}
                </div>
                <div
                    className={'trend__topmenu' + (visibleTopMenu ? ' visibleTop' : ' notvisibleTop')}
                    style={{ height: HeightTopMenu }}>
                    <div style={{ width: '120px', position: 'absolute', right: '0px', display: 'flex' }}>
                        <ButtonIcon
                            title="Масштабирование области"
                            onClick={() => {
                                if (activeTopBut != 'ActiveZoomSelect') {
                                    setActiveTopBut('ActiveZoomSelect');
                                    graphRef?.current?.ActiveZoomSelect();
                                } else {
                                    setActiveTopBut('');
                                    graphRef?.current?.DefaultCursor();
                                }
                            }}
                            active={activeTopBut == 'ActiveZoomSelect'}
                            src="/ixyber/vision/static/images/trends/main/Scale.svg"
                        />

                        <ButtonIcon
                            title="Сброс"
                            onClick={() => {
                                setActiveTopBut('');
                                graphRef?.current?.ZoomReset();
                            }}
                            src="/ixyber/vision/static/images/trends/main/Update.svg"
                        />

                        <ButtonIcon
                            title="Выделить срез"
                            onClick={() => {
                                if (activeTopBut != 'HorizontSelect') {
                                    setActiveTopBut('HorizontSelect');
                                    graphRef?.current?.HorizontSelect();
                                } else {
                                    setActiveTopBut('');
                                    graphRef?.current?.DefaultCursor();
                                }
                            }}
                            active={activeTopBut == 'HorizontSelect'}
                            src="/ixyber/vision/static/images/trends/main/Horizont_select.svg"
                        />
                        <ButtonIcon
                            title="Множественный срез"
                            onClick={() => {
                                if (activeTopBut != 'KeepSelect') {
                                    setActiveTopBut('KeepSelect');
                                    graphRef?.current?.KeepSelect();
                                } else {
                                    setActiveTopBut('');
                                    graphRef?.current?.DefaultCursor();
                                }
                            }}
                            active={activeTopBut == 'KeepSelect'}
                            src="/ixyber/vision/static/images/trends/main/Keep_select.svg"
                        />

                        <ButtonIcon
                            title="Показать/скрыть таблицу данных"
                            onClick={() => {
                                setvisibleBottomMenu(!visibleBottomMenu);
                            }}
                            active={visibleBottomMenu}
                            src="/ixyber/vision/static/images/trends/main/Show_menu.svg"
                        />
                    </div>
                </div>
                <div
                    className={'trend__graph' + (visibleBottomMenu ? ' visibleBottom' : ' notvisibleBottom')}
                    style={{ height: HeightGraph }}>
                    <TrendsGraphs
                        ref={graphRef}
                        id={idTrend}
                        data={archive}
                        pens={HmiHistorySettings}
                        echarts_react={echarts_react}
                        notMerge={notMerge}
                        calbacUpdateRow={calbacUpdateRow}
                        config={config}
                        newSeriesPoints={newSeriesPoints}
                    />
                </div>
                <div
                    className={'trend__bottom' + (visibleBottomMenu ? ' visibleBottom' : ' notvisibleBottom')}
                    style={{ height: HeightBootomMenu }}>
                    <TrendsTable
                        items={HmiHistorySettings}
                        calbackEditItem={ChangeItem}
                        UpdateEnableState={UpdateEnableState}
                        UpdateMin={UpdateMin}
                        UpdateMax={UpdateMax}
                        calbackClickRow={calbackClickRow}
                    />
                </div>
            </div>
        );
    } else if (dialogisopen) {
        return <FormDialog setNumber={updateGroup} />;
    } else {
        return <LoadPage visible={true} />;
    }
};

export default TrendsIndex;

interface IDialog {
    setNumber: any;
}

function FormDialog(props: IDialog) {
    const [open, setOpen] = React.useState(true);
    const [numgroup, setNumgroup] = React.useState(1);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        props.setNumber(numgroup, '');
    };

    const handleChange = (e: any) => {
        setNumgroup(e.target.value);
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogContent>
                    <DialogContentText>Введите номер группы:</DialogContentText>
                    <TextField
                        autoFocus
                        size="small"
                        margin="dense"
                        id="numgroup"
                        label="Номер группы"
                        type="number"
                        value={numgroup}
                        onChange={(e: any) => handleChange(e)}
                        fullWidth
                        onKeyPress={(ev: any) => {
                            if (ev.key === 'Enter') {
                                handleClose();
                                ev.preventDefault();
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Открыть тренд
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function useInterval(callback: any, delay: any) {
    const savedCallback: any = React.useRef();

    // Remember the latest callback.
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    React.useEffect(() => {
        function tick() {
            if (savedCallback) savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
